import { render, staticRenderFns } from "./NavBtn.vue?vue&type=template&id=31c98190&scoped=true&"
import script from "./NavBtn.vue?vue&type=script&lang=js&"
export * from "./NavBtn.vue?vue&type=script&lang=js&"
import style0 from "./NavBtn.vue?vue&type=style&index=0&id=31c98190&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c98190",
  null
  
)

component.options.__file = "NavBtn.vue"
export default component.exports